let debug = false;

function fq_print(level, messages, color) {
    const currentDate = new Date().toLocaleTimeString();
    const prefix = `%c[${level.toUpperCase()}][${currentDate}]%c`;
    const resetStyle = "color:inherit;";

    if ( debug ) {
        console.log(prefix, `color:${color};`, resetStyle, ...messages);
    }
}
function fq_debug(...messages) {
    fq_print("debug", messages, "#32c8e6");
}
function fq_debug_payload(messages, objects) {
    fq_print("debug", [messages, objects], "#32c8e6");
}
function fq_info(...messages) {
    fq_print("info", messages, "#3cf051");
}
function fq_warn(...messages) {
    fq_print("warn", messages, "#fac837");
}
function fq_error(...messages) {
    fq_print("error", messages, "#e63232");
}


let fqSearch = document.querySelector('.fq-search input[type="search"]');
let fqSearchCategories = document.querySelectorAll('[data-search-category]');
let fqMobileToggle = document.querySelector('.fq-mobile__toggle');
let fqItems = document.querySelectorAll('.fq-item');

/**
 * Reset all categories
 */
function fqResetCategories() {
    fqSearchCategories.forEach(fqSearchCategory => {
        fqSearchCategory.classList.remove( 'fq-filter__category--active' );
        fqSearchCategory.classList.remove('fq-filter__sub--active');
        fqSearchCategory.classList.remove('fq-filter__sub--show');
        fqSearchCategory.classList.remove('fq-filter__head--active');
    });

    fq_debug_payload('Reset categories, remove classes fq-filter__category--active, fq-filter__sub--active, fq-filter__sub--show, fq-filter__head--active.', fqSearchCategories);
}

/**
 * Reset all items
 */
function fqResetItems() {
    fqItems.forEach(fqItem => {
        fqItem.classList.remove('fq-item--hidden');
        fqItem.classList.remove('fq-item--highlight');
        fqItem.classList.remove('fq-item--active');
    });

    fq_debug_payload('Reset items, remove classes fq-item--hidden, fq-item--highlight, fq-item--active.', fqItems);
}

/**
 * Reset search input
 */
function fqResetSearch() {
    fqSearch.value = '';
}

/**
 * When user clicks on ANY fq-item, add class fq-item--active to the clicked element.
 */
fqItems.forEach(fqItem => {
    fqItem.querySelector('.fq-item__question').addEventListener('click', function () {
        if( fqItem.classList.contains('fq-item--active') ) {
            fqItem.classList.remove('fq-item--active');

            fq_debug_payload('Remove class fq-item--active.', fqItem);
        }
        else {
            fqItem.classList.add('fq-item--active');

            fq_debug_payload('Add class fq-item--active.', fqItem);
        }
    });
});

/**
 * When user types in the search input, search for the text in fq-item__question and fq-item__answer
 */
fqSearch.addEventListener('input', function () {
    let search = fqSearch.value.toLowerCase();

    if( search === '' ) {
        fqResetItems();
        return;
    }

    /**
     * Reset categories
     */
    fqResetCategories();

    /**
     * Loop through all fqItems and add class fq-item--active and fq-item--highlight
     */
    fqItems.forEach(fqItem => {
        /**
         * Let search in fq-item__question and fq-item__answer
         */
        let searchIn = ['fq-item__question h4', 'fq-item__answer'];

        /**
         * If the search text is found in the searchIn, add class fq-item--active and fq-item--highlight
         * @type {boolean}
         */
        let found = false;
        searchIn.forEach(selector => {
            let text = fqItem.querySelector(`.${selector}`).textContent;
            if (text.toLowerCase().indexOf(search) > -1) {
                found = true;
            }
        });

        if (found) {
            fqItem.classList.add('fq-item--active');
            fqItem.classList.add('fq-item--highlight');

            fq_debug_payload('Add classes fq-item--active, fq-item--highlight.', fqItem);
        }
        else {
            fqItem.classList.remove('fq-item--active');
            fqItem.classList.remove('fq-item--highlight');
            fqItem.classList.add('fq-item--hidden')

            fq_debug_payload('Remove classes fq-item--active, fq-item--highlight, add class fq-item--hidden.', fqItem);
        }
    });
});

let head_level_selected = null;

/**
 * When user clicks on ANY data-search-category="faq" element, get the data-search-value and search for it.
 */
fqSearchCategories.forEach(fqSearchCategory => {
    fqSearchCategory.addEventListener('click', function () {
        /**
         * Reset search input
         */
        fqResetSearch();


        let search = fqSearchCategory.getAttribute( 'data-search-category' );
        let is_sub = fqSearchCategory.hasAttribute('data-search-parent');

        if( search === '' || search === 'reset' ) {
            /**
             * Reset items
             * Reset categories
             */
            fqResetItems();
            fqResetCategories();
            return;
        }

        // if( is_sub ) {
        //     fqSearchCategories.forEach(x => {
        //         if (x.getAttribute('data-search-category') === fqSearchCategory.getAttribute('data-search-parent')) {
        //          //   x.click();
        //         }
        //     });
        // }

        fqSearchCategories.forEach(fqSearchCategory => {
            if( ! is_sub ) {
                if( fqSearchCategory.getAttribute('data-search-category') === search ) {
                    fqSearchCategory.classList.add('fq-filter__head--active');
                    head_level_selected = search;

                    fqSearchCategories.forEach(sub => {
                        if (sub.getAttribute('data-search-parent') === head_level_selected) {
                            sub.classList.add('fq-filter__sub--show');
                            sub.classList.remove('fq-filter__sub--active');

                            fq_debug_payload(`Add class fq-filter__sub--show, remove class fq-filter__sub--active.`, sub);
                        }
                        else {
                            sub.classList.remove('fq-filter__sub--show');
                            sub.classList.remove('fq-filter__sub--active');

                            fq_debug_payload(`Remove class fq-filter__sub--show, fq-filter__sub--active.`, sub);
                        }
                    });
                }
                else {
                    fqSearchCategory.classList.remove('fq-filter__head--active');
                }
            }

            else {
                if( fqSearchCategory.getAttribute('data-search-category') === search ) {
                    fqSearchCategory.classList.add('fq-filter__sub--active');

                    fq_debug_payload(`Add class fq-filter__sub--active.`, fqSearchCategory);
                }
                else {
                    fqSearchCategory.classList.remove('fq-filter__sub--active');

                    fq_debug_payload(`Remove class fq-filter__sub--active.`, fqSearchCategory);
                }
            }
        });

        fqItems.forEach(fqItem => {
            let category = fqItem.getAttribute( 'data-category' ).split('|') ?? '';

            if (category.includes(search) )  {
                fqItem.classList.remove('fq-item--hidden' );

                fq_debug_payload(`Remove class fq-item--hidden.`, fqItem);
            }
            else {
                fqItem.classList.add( 'fq-item--hidden' );

                fq_debug_payload(`Add class fq-item--hidden.`, fqItem);
            }

            // get all fq-item__categories in item
            fqItem.querySelectorAll('.fq-item__categories li').forEach(fqItemCategory => {
                let head_slug = fqItemCategory.getAttribute('data-category-slug');
                if( head_level_selected !== head_slug ) {
                    fqItemCategory.style.display = 'none';
                }
                else {
                    fqItemCategory.style.display = 'block';
                }

                console.log(head_slug, head_level_selected);

            });

        });
    });
});

/**
 * When user clicks on fq-mobile__toggle, add class fq-mobile--active to the parent element.
 */
fqMobileToggle.addEventListener('click', function () {
    fqMobileToggle.parentElement.classList.toggle('fq-mobile--active');

    fq_debug_payload(`Toggle class fq-mobile--active.`, fqMobileToggle.parentElement);
});

/**
 * When the page loads, check if there is a hash in the URL.
 */
if( window.location.hash ) {
    let hash = window.location.hash.replace('#', '');
    let fqItems = document.querySelectorAll(`[data-category*="${hash}"]`);

    if( fqItems.length === 0 ) {
        fqItems = document.querySelectorAll(`[data-slug="${hash}"]`)

        fq_debug_payload(`No items found with data-category="${hash}", search for data-slug="${hash}".`, fqItems);
    }

    if(fqItems.length === 1) {
        fqItems.forEach(fqItem => {
            fqItem.classList.add('fq-item--active')
            fqItem.classList.add('fq-item--highlight');
        });

        fq_debug_payload(`Add classes fq-item--active, fq-item--highlight.`, fqItems);
    }

    let source =  document.querySelector(`[data-search-category*="${hash}"]`);
    if( source ) {
        let parent = source.getAttribute('data-search-parent');
        if( parent ) {
            let parent_source = document.querySelector(`[data-search-category="${parent}"]`);

            if( parent_source ) {
                parent_source.click();
                fq_debug_payload(`Click on parent source.`, parent_source);
            }
        }

        source.click();
        fq_debug_payload(`Click on source.`, source);
    }

    if(fqItems.length === 1) {
        let fqItem = fqItems[0];
        if( fqItem ) {
            fqItem.scrollIntoView();
            fq_debug_payload(`Scroll into view.`, fqItem);
        }
    }
}